const msgLigs = {
    'Incorrect data': 'Please check entered data',
    'Incorrect password': 'Please check entered data',
    'Token does not exist': 'Token is outdated. Please try one more time!',
    notFound: 'There is no matching account in the system. Please contact your Administrator.',
};

export const getHumanError = (msg) => {
    return msgLigs[msg] ? msgLigs[msg] : msg;
};
